

















import { scrollTo } from '@/utils/scrollTo';
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class Pagination extends Vue {
  // "!" 代表必须 和 required: true 对应。? 代表可选和!相反
  @Prop(Number) private total!: number;
  @Prop(Number) private page!: number;
  @Prop(Number) private limit!: number;
  @Prop(Boolean) private background!: boolean;
  @Prop(Boolean) private autoScroll!: boolean;
  @Prop(Boolean) private hidden!: boolean;
  @Prop({
    type: Array,
    default() {
      return [10, 20, 30, 50];
    },
  })
  private pageSizes?: number[];
  @Prop({
    type: String,
    default() {
      return 'total, sizes, prev, pager, next, jumper';
    },
  })
  private layout?: string;

  public get currentPage(): number {
    return this.page;
  }

  public set currentPage(v: number) {
    this.$emit('update:page', v);
  }

  public get pageSize(): number {
    return this.limit;
  }

  public set pageSize(v: number) {
    this.$emit('update:limit', v);
  }

  public handleSizeChange(val: number) {
    this.$emit('pagination', { page: this.currentPage, limit: val });
    if (this.autoScroll) {
      scrollTo(0, 800);
    }
  }

  public handleCurrentChange(val: number) {
    this.$emit('pagination', { page: val, limit: this.pageSize });
    if (this.autoScroll) {
      scrollTo(0, 800);
    }
  }
}
